import React from "react";
import { Link } from "react-router-dom";
import MarketingLayout from "../components/site/MarketingLayout";
import QrifyMark from "../components/site/QrifyMark";

const sections = [
  "Acceptance",
  "Who we are",
  "The service",
  "Not a substitute for emergency services",
  "Eligibility",
  "Accounts and OTP",
  "User responsibilities",
  "Lifesavr / rescuer use",
  "Health and AI features",
  "Payments",
  "Privacy",
  "Intellectual property",
  "Disclaimers",
  "Limitation of liability",
  "Suspension and termination",
  "Changes",
  "Governing law",
  "Contact",
];

const TermsOfUse = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <MarketingLayout>
      <div className="sv-policy">
        <section className="sv-policy__hero">
          <div className="sv-container">
            <h1 className="sv-h1">
              Terms & Conditions
            </h1>
            <p className="sv-policy__hero-meta">
              Svasth / <QrifyMark /> · Operator: ALEgION Health Tech Private Limited ·
              Last updated: 10 August 2026
            </p>
            <p className="sv-policy__hero-meta">
              Also review our{" "}
              <Link to="/privacy">Privacy Policy</Link>
            </p>
          </div>
        </section>

        <div className="sv-policy__content">
          <div className="sv-toc">
            <strong>Contents</strong>
            <ol>
              {sections.map((title, i) => (
                <li key={title}>
                  <a
                    href={`#section-${i + 1}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(`section-${i + 1}`);
                    }}
                  >
                    {title}
                  </a>
                </li>
              ))}
            </ol>
          </div>

          <p>
            These Terms apply to the Svasth / <QrifyMark /> app,{" "}
            <QrifyMark /> Emergency Lite, and related services at svasth.ai.
            Please also read our{" "}
            <Link to="/privacy">Privacy Policy</Link>.
          </p>

          <section id="section-1">
            <h2>1. Acceptance</h2>
            <p>
              By accessing svasth.ai, scanning a <QrifyMark /> code, creating an
              account, or using emergency, AI, payment, or related features, you
              agree to these Terms. If you do not agree, do not use the
              services.
            </p>
          </section>

          <section id="section-2">
            <h2>2. Who we are</h2>
            <p>
              ALEgION Health Tech Private Limited operates Svasth / <QrifyMark />{" "}
              emergency identification and response services.
            </p>
            <ul>
              <li>Email: tech@svasth.ai</li>
              <li>
                Privacy: tech@svasth.ai 
              </li>
              <li>
                Postal: ALEgION Health Tech Private Limited, New No. 7C, Perumal
                Koil Street, Nerkundram, Chennai, Tamil Nadu 600107
              </li>
            </ul>
          </section>

          <section id="section-3">
            <h2>3. The service</h2>
            <p>
              <QrifyMark /> helps identify a person in an emergency and notify helpers,
              family, and (where enrolled or required) hospital/ambulance
              partners. Features may include QR identity, medical profile,
              emergency contacts, location sharing, OTP login, push
              notifications, AI assistance (Swastika / injury analysis), and
              paid plans.
            </p>
          </section>

          <section id="section-4">
            <h2>4. Not a substitute for emergency services</h2>
            <div className="sv-callout">
              <QrifyMark /> does not replace 112, ambulance, hospital, or other
              emergency services. We do not guarantee response time, dispatch,
              hospital admission, or clinical outcome. If someone is in danger,
              call local emergency services immediately.
            </div>
          </section>

          <section id="section-5">
            <h2>5. Eligibility</h2>
            <p>
              Services are directed to adults and guardians managing family
              profiles. You must have legal capacity to contract. You are
              responsible for the accuracy of data you enter for yourself and
              for family members you manage.
            </p>
          </section>

          <section id="section-6">
            <h2>6. Accounts and OTP</h2>
            <p>
              You must keep your mobile number, OTP, and device secure. You are
              responsible for activity on your account. We may suspend accounts
              for fraud, abuse, or security risk.
            </p>
          </section>

          <section id="section-7">
            <h2>7. User responsibilities</h2>
            <p>You agree to:</p>
            <ul>
              <li>Provide accurate profile and medical information</li>
              <li>
                Use the service only for genuine emergencies, tests, or
                permitted purposes
              </li>
              <li>Not impersonate others</li>
              <li>
                Not misuse QR codes, location, AI, or helper data
              </li>
              <li>Not attempt unauthorised access</li>
            </ul>
          </section>

          <section id="section-8">
            <h2>8. Lifesavr / rescuer use</h2>
            <p>
              If you scan a QR or assist someone, you do so voluntarily. Provide
              accurate name and phone when requested. Location and related data
              may be used to deliver assistance, as described in the{" "}
              <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </section>

          <section id="section-9">
            <h2>9. Health and AI features</h2>
            <p>
              Blood group, conditions, allergies, medications, and other health
              details are provided by you. AI (including Google Gemini) may
              analyse text, voice, images, or video you submit. AI output is
              informational only — not diagnosis, treatment, or medical advice.
              Some AI processing may occur outside India.
            </p>
          </section>

          <section id="section-10">
            <h2>10. Payments</h2>
            <p>
              Paid plans are processed via Razorpay. Fees, renewals, and taxes
              are shown at checkout. Refunds follow applicable law and the plan
              terms shown at purchase.
            </p>
          </section>

          <section id="section-11">
            <h2>11. Privacy</h2>
            <p>
              Personal data is handled under the{" "}
              <Link to="/privacy">Privacy Policy</Link> (DPDP Act, 2023).
              Processors may include SMS/voice gateways, FCM/OneSignal, AWS,
              Google Gemini, Razorpay, MongoDB Atlas, and care/hospital partners
              where you are enrolled or an emergency dispatch is needed.
            </p>
          </section>

          <section id="section-12">
            <h2>12. Intellectual property</h2>
            <p>
              Svasth, <QrifyMark />, Swastika, and related marks, software, and content
              belong to ALEgION Health Tech Private Limited or its licensors.
              You may not copy, reverse engineer, or use them except as allowed
              to use the service.
            </p>
          </section>

          <section id="section-13">
            <h2>13. Disclaimers</h2>
            <p>
              Services are provided on an &quot;as is&quot; and &quot;as
              available&quot; basis. We do not warrant uninterrupted access,
              error-free AI, or that helpers, hospitals, or networks will always
              be reachable.
            </p>
          </section>

          <section id="section-14">
            <h2>14. Limitation of liability</h2>
            <p>
              To the maximum extent permitted by Indian law, Alegion Health Tech
              Private Limited is not liable for indirect, incidental, or
              consequential loss, or for delay or failure of third-party
              networks, hospitals, ambulances, payment gateways, or AI
              providers. Nothing in these Terms excludes liability that cannot
              be excluded by law.
            </p>
          </section>

          <section id="section-15">
            <h2>15. Suspension and termination</h2>
            <p>
              We may suspend or end access for breach, legal requirement, or
              security. You may delete your account as described in the Privacy
              Notice. Some records may be retained where required by law (for
              example payments and security logs).
            </p>
          </section>

          <section id="section-16">
            <h2>16. Changes</h2>
            <p>
              We may update these Terms. The &quot;Last updated&quot; date will
              change. Continued use after an update means you accept the new
              Terms, except where law requires a fresh consent.
            </p>
          </section>

          <section id="section-17">
            <h2>17. Governing law</h2>
            <p>
              These Terms are governed by the laws of India. Courts at Chennai,
              Tamil Nadu have exclusive jurisdiction, subject to mandatory
              consumer or other protections.
            </p>
          </section>

          <section id="section-18">
            <h2>18. Contact</h2>
            <p>
              Questions: tech@svasth.ai · Website:{" "}
              <a href="https://svasth.ai" rel="noopener noreferrer">
                https://svasth.ai
              </a>
            </p>
            <p>
              Privacy Policy:{" "}
              <Link to="/privacy">https://svasth.ai/privacy</Link>
            </p>
          </section>

          <p className="sv-policy__foot">
            © {new Date().getFullYear()} ALEgION Health Tech Private Limited ·
            Svasth / <QrifyMark />
          </p>
        </div>
      </div>
    </MarketingLayout>
  );
};

export default TermsOfUse;
